import React, { useContext, useEffect, useState } from "react";
import AdvancedFilterBar from "../shared/AdvancedFilterBar";
import InventoryHistoryTable from "./InventoryHistoryTable";
import { fetchInventoryHistory } from "../../services/MaterialAPI";
import { HistoryItem } from "../../types/InventoryHistory";
import FormComponent from "../generic/FormComponent";
import { UserContext } from "../../context/UserContext";

const HistoryForm: React.FC = () => {
    const [ history, setHistory ] = useState<HistoryItem[]>([]);
    const [ filteredData, setFilteredData ] = useState<HistoryItem[]>([]);
    const [ filters, setFilters ] = useState<{
        start_date?: string;
        end_date?: string;
        material_type?: number | null;
        color_code?: string | null;
        size?: number | null;
    }>({});
    const [ currentPage, setCurrentPage ] = useState<number>(1);
    const { isLoggedIn } = useContext(UserContext);

    // Fetch data based on date filters and pagination
    useEffect(() => {
        const loadHistory = async () => {
            try {
                const data = await fetchInventoryHistory({
                    start_date: filters.start_date,
                    end_date: filters.end_date,
                });
                setHistory(data.records || []);
                setFilteredData(data.records || []); // Initially set filtered data to all records
            } catch (error) {
                console.error("Error fetching inventory history:", error);
            }
        };

        loadHistory();
    }, [ filters.start_date, filters.end_date, currentPage, isLoggedIn ]);

    // Apply local filtering for material type, size, and color
    useEffect(() => {
        const applyLocalFilters = () => {
            const { material_type, color_code, size } = filters;
            let filtered = history;

            if (material_type !== null && material_type !== undefined) {
                filtered = filtered.filter(record => record.material_type_id === material_type);
            }

            if (size !== null && size !== undefined) {
                filtered = filtered.filter(record => record.material_size_id === size);
            }

            if (color_code) {
                filtered = filtered.filter(record => record.color_code === color_code);
            }

            setFilteredData(filtered);
        };

        applyLocalFilters();
    }, [ filters.material_type, filters.color_code, filters.size, history ]);

    // Calculate total balance
    const totalBalance = filteredData.reduce((sum, item) => sum + (item.balance || 0), 0);

    return (
        <div>
            <FormComponent title={"Inventory History"}>
                {/* Filter Bar for Advanced Filtering */}
                <AdvancedFilterBar
                    filters={filters}
                    data={history} // Pass the fetched data to AdvancedFilterBar for local filtering
                    onChange={(updatedFilters) => {
                        setFilters(updatedFilters); // Update filters when they change
                        setCurrentPage(1); // Reset pagination to the first page
                    }}
                    onFilterData={(filteredData) => setFilteredData(filteredData)} // Update filtered data
                />

                {/* Display Total Balance */}
                {/*<TotalBalance totalBalance={totalBalance}/>*/}

                {/* Display the Inventory History Table */}
                <div>
                    <InventoryHistoryTable data={filteredData}
                                           currentPage={currentPage}
                                           setCurrentPage={setCurrentPage}
                    />
                </div>
            </FormComponent>
        </div>
    );
};

export default HistoryForm;
